export default __webpack_public_path__ + "cbd5b4427da7332b340e85c6ed326432.png";